webpackJsonp([27],{

/***/ "1/XJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");








var TOTAL_COLUMNS = 12;
var COLUMN_OPTIONS = [{ label: '0%', value: 0 }, { label: '8.3%', value: 1 }, { label: '16.6%', value: 2 }, { label: '25%', value: 3 }, { label: '33.3%', value: 4 }, { label: '41.6%', value: 5 }, { label: '50%', value: 6 }, { label: '58.3%', value: 7 }, { label: '66.6%', value: 8 }, { label: '75%', value: 9 }, { label: '83%', value: 10 }, { label: '91.6%', value: 11 }];
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    previewId: {}
  },
  data: function data() {
    return {
      COLUMN_OPTIONS: COLUMN_OPTIONS,
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0]
      }
    };
  },

  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  computed: {
    isColumnCountExceeding: function isColumnCountExceeding() {
      return this.columnChoice.left.value + this.columnChoice.right.value >= TOTAL_COLUMNS;
    },
    middleOption: function middleOption() {
      var sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses: function leftColumnClasses() {
      var option = this.columnChoice.left.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + option, !!option);
    },
    middleColumnClasses: function middleColumnClasses() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + this.middleOption, !!this.middleOption);
    },
    rightColumnClasses: function rightColumnClasses() {
      var option = this.columnChoice.right.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, option, !!option);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPagePreview(this.previewId).then(function (data) {
      _this.loaderRemove(document.body);
      _this.installDynamicControls({ data: data });
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPagePreview']))
});

/***/ }),

/***/ "91yt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.page-static-preview{padding:20px 12px 0}.page-static-preview__box{margin-bottom:20px}.page-static-preview .img-caption{text-align:center}.page-static-preview blockquote,.page-static-preview dd,.page-static-preview div,.page-static-preview dl,.page-static-preview dt,.page-static-preview form,.page-static-preview h1,.page-static-preview h2,.page-static-preview h3,.page-static-preview h4,.page-static-preview h5,.page-static-preview h6,.page-static-preview li,.page-static-preview ol,.page-static-preview p,.page-static-preview pre,.page-static-preview td,.page-static-preview th,.page-static-preview ul{overflow-wrap:break-word}.page-static-preview .browse-static-page-content-region-image-container,.page-static-preview .twitter-tweet-rendered{margin:0 auto!important}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/pages/page-static-preview/page-static-preview.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,qBACE,mBAAqB,CACtB,AACD,0BACI,kBAAoB,CACvB,AACD,kCACI,iBAAmB,CACtB,AACD,mdAmBI,wBAA0B,CAC7B,AAID,qHACI,uBAA0B,CAC7B","file":"page-static-preview.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.page-static-preview {\n  padding: 20px 12px 0;\n}\n.page-static-preview__box {\n    margin-bottom: 20px;\n}\n.page-static-preview .img-caption {\n    text-align: center;\n}\n.page-static-preview div,\n  .page-static-preview dl,\n  .page-static-preview dt,\n  .page-static-preview dd,\n  .page-static-preview ul,\n  .page-static-preview ol,\n  .page-static-preview li,\n  .page-static-preview h1,\n  .page-static-preview h2,\n  .page-static-preview h3,\n  .page-static-preview h4,\n  .page-static-preview h5,\n  .page-static-preview h6,\n  .page-static-preview pre,\n  .page-static-preview form,\n  .page-static-preview p,\n  .page-static-preview blockquote,\n  .page-static-preview th,\n  .page-static-preview td {\n    overflow-wrap: break-word;\n}\n.page-static-preview .twitter-tweet-rendered {\n    margin: 0 auto !important;\n}\n.page-static-preview .browse-static-page-content-region-image-container {\n    margin: 0 auto !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "SA4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-static-preview"},[(_vm.isColumnCountExceeding)?_c('alert-box',{staticClass:"page-static-preview__box",attrs:{"level":"warning"}},[_vm._v("\n    Column setup appears to be invalid (either exceeds 100% or content column broke to next row).\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-12 medium-6"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Left Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.left),callback:function ($$v) {_vm.$set(_vm.columnChoice, "left", $$v)},expression:"columnChoice.left"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-6"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Right Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.right),callback:function ($$v) {_vm.$set(_vm.columnChoice, "right", $$v)},expression:"columnChoice.right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:_vm.leftColumnClasses},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{class:_vm.middleColumnClasses,domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{class:_vm.rightColumnClasses},[_vm._v("\n       \n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WDNh":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("91yt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("89f3f874", content, true, {});

/***/ }),

/***/ "n58p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_static_preview_js__ = __webpack_require__("1/XJ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ddbab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_static_preview_vue__ = __webpack_require__("SA4y");
function injectStyle (ssrContext) {
  __webpack_require__("WDNh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_static_preview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ddbab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_static_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/27.80c82c4308cdf8870a9c.js